import { createContext } from 'react';

const tenantsContext = createContext();

export default tenantsContext;
